import React from 'react';
import TablaConfgFechas from '../components/minas/tablaConfigFecha';

function ConfVecha() {
  return (
    <div className='p-0 m-0'>
       <TablaConfgFechas/>
    </div>
  );
}

export default ConfVecha;




// WEBPACK FOOTER //
// ./src/pages/configfechamina.js